
<template>

  <div class="four wide mobile two wide tablet two wide computer center aligned column">

    <div class="block"
      :class="{ active: quarter.status === 'reserved',
                disabled: quarter.status === 'taken' || quarter.status === 'read' }"
      @click="$emit('select-quarter')">

      <span class="ui big text">{{ quarter.ordering + 1 }}</span>

    </div>

  </div>

</template>

<script>
export default {

  name: 'QuarterBlock',
  props: {

    quarter: Object

  }

}
</script>

<style lang="scss" scoped>
.block {
  cursor: pointer;

  margin: auto;
  height: 4.2em;
  width: 100%;

  padding-top: 0.4em;

  border: 0.15em solid #3c8c45;
  color: #3c8c45;

  &.active {
    background-color: #3c8c45;
    color: white;
  }

  &.disabled {
    pointer-events: none;

    border: 0.15em solid rgba(40, 40, 40, 0.1);
    color: rgba(40, 40, 40, 0.1);
  }
}
</style>
